import { render, staticRenderFns } from "./aiLectureAddPage.vue?vue&type=template&id=16d0646a&scoped=true&"
import script from "./aiLectureAddPage.vue?vue&type=script&lang=js&"
export * from "./aiLectureAddPage.vue?vue&type=script&lang=js&"
import style0 from "./aiLectureAddPage.vue?vue&type=style&index=0&id=16d0646a&prod&scoped=true&lang=scss&"
import style1 from "./aiLectureAddPage.vue?vue&type=style&index=1&id=16d0646a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d0646a",
  null
  
)

export default component.exports